import { render, staticRenderFns } from "./SendDocumentsSponsor.vue?vue&type=template&id=c9c342c0&scoped=true&"
import script from "./SendDocumentsSponsor.vue?vue&type=script&lang=ts&"
export * from "./SendDocumentsSponsor.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocumentsSponsor.vue?vue&type=style&index=0&id=c9c342c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c342c0",
  null
  
)

export default component.exports